export default __webpack_public_path__ + "static/media/auditorium_mockup_without_seat.71e69bb2.svg";